import { schema } from "normalizr";
import { CarrierServiceList } from "./carrier-service-list";

export const CarrierServiceLists = new schema.Array(CarrierServiceList);
